import { Route } from 'types/route.type';
import EditCustomer from './components/edit-customer';
import ListCustomers from './list-customers';

export const routes: Route[] = [
  {
    path: '/feed-management/customers',
    component: ListCustomers,
    id: 'feedManagement.navigation.listCustomers',
  },
  {
    path: '/feed-management/customers/:id',
    component: EditCustomer,
  },
];
